import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { DetailMessage } from './DetailMessage';
import { PrimaryResourceDisplay } from './PrimaryResourceDisplay';
import { SuccessMessage } from './SuccessMessage';
import { s } from './styles';
import { IAIScheduleSuccessProps } from './types';

interface SingleResourceLayoutProps {
	props: IAIScheduleSuccessProps;
	onClose: () => void;
}

export const SingleResourceLayout: React.FC<SingleResourceLayoutProps> = ({ props, onClose }) => {
	const successMessageContent = <SuccessMessage props={props} />;
	const detailMessageContent = <DetailMessage props={props} />;
	const hasSuccessMessage = Boolean(successMessageContent);

	return (
		<div className={css(s.singleResourceLayout)}>
			<PrimaryResourceDisplay
				resource={{
					type: props.resourceType,
					content: {} as any,
					isCompleted: true,
					scheduledDate: props.estimate?.estimate?.startDate
						? moment(props.estimate.estimate.startDate).toDate()
						: props.socialPost?.dueMoment
							? moment(props.socialPost.dueMoment).toDate()
							: props.blogPost?.scheduledSendDate
								? moment(props.blogPost.scheduledSendDate).toDate()
								: undefined,
				}}
				props={props}
				showScheduledText={!hasSuccessMessage}
			/>

			<div className={css(s.successCallout)}>
				<div className={css(s.successHeading)}>Success!</div>
				{successMessageContent}
				{detailMessageContent}
				<Button variant='primary' styles={[s.closeButton]} onClick={onClose}>
					Close Window
				</Button>
			</div>
		</div>
	);
};
